import React, { useCallback } from "react";
import { Footer } from "@bloomberg/media-ui-nav";
import { type SubmenuItem } from "@bloomberg/media-ui-nav/dist/types";

import { Tracker } from "~utils/tracker";

import styles from "./Footer.module.css";

const tracker = new Tracker({
    category: "footer",
});

const addPrivacyManager = (link: HTMLButtonElement) => {
    window.cmpClient.cmd.push(() => {
        const cmpClient = window.getCmpClient();
        cmpClient.addPrivacyManager(link);
    });
};

export default function NavFooter({
    footerMenuItems,
}: {
    footerMenuItems: Record<string, SubmenuItem>;
}) {
    const trackingFunction = useCallback(
        (eventAction: string, eventLabel: string) => {
            tracker.trackEvent({
                event: "footerClick",
                action: eventAction,
                label: eventLabel,
            });
        },
        []
    );

    return (
        <Footer
            addPrivacyManager={addPrivacyManager}
            name="footer"
            desktopBreakpointClassName={styles.footerDesktop}
            footerMenuItems={footerMenuItems}
            trackingFunction={trackingFunction}
        />
    );
}
